import { addError } from '@/global/plugins/observability'
import { finishSimulation, FinishSimulationArgs } from '@/modules/simulator/api'
import {
  Context,
  SimulatorCode
} from '@/global/plugins/observability/observability.constants'
import { useMutation } from '@tanstack/react-query'
import { useSearchParams } from 'next/navigation'
import { useContext } from 'react'
import { toast } from 'react-toastify'
import { SimulatorContext } from '@/modules/simulator/contexts'
import { getTrackingInfoUtms } from '@/modules/simulator/functions/getTrackingInfoUtms/getTrackingInfoUtms'
import { getAnonymousId } from '@/global/utils'

interface UseFinishSimulationProps {
  onSuccess?: () => void
}

const useFinishSimulation = ({
  onSuccess
}: UseFinishSimulationProps | undefined = {}) => {
  const { simulation } = useContext(SimulatorContext)
  const searchParams = useSearchParams()

  const finishSimulationPayload: FinishSimulationArgs = {
    id: simulation.id,
    payload: {
      trackingInfo: {
        ...(searchParams ? getTrackingInfoUtms(searchParams) : {}),
        anonymousId: getAnonymousId() || ''
      }
    }
  }

  const onError = (error: Error) => {
    addError({
      error,
      data: {
        context: Context.SIMULATOR,
        code: SimulatorCode.FINISH_SIMULATION_ERROR,
        message: 'Erro ao finalizar simulação',
        location: 'useFinishSimulation'
      }
    })

    toast('Ops! Tivemos um problema. Tente novamente mais tarde')
  }

  return useMutation<void, Error>({
    mutationFn: () => finishSimulation(finishSimulationPayload),
    onError,
    onSuccess
  })
}

export { useFinishSimulation }
